import { useState, useEffect, useCallback } from "react";
import { useNotification } from "@orbital/games-frontend-library";
import {
  defaultAppCTX,
  defaultVauleCTX,
  roundUserContext,
} from "../context/defaultContext";
import { roundUpdateHelper } from "./roundUpdateHelper";
import {
  handleFuncsInAppContext,
  setGameAudioHelper,
} from "./handleContextHelper";
// import { useStellarSocketMessages } from "../lib/stellarSocketMessages"
import { useReceiveMessages } from "../socket/receiveMessages";
import { sendMessages } from "../socket/sendMessages";
import { handleErrors } from "../socket/handleErrors";
import { Notifications } from "../lib/constants";
import { useTranslation } from "../locale/context";

export default function useContextUpdateFromSocket(
  socket: any,
  MessagesList: any,
  name: any
) {
  const [context, setContext] = useState(defaultAppCTX);
  const [roundValue, setRoundValue] = useState(defaultVauleCTX);
  const [newRoundUser, setNewRoundUser] = useState(roundUserContext);
  const { globalSocketMessages, stellarSocketMessages } = new sendMessages(
    socket
  );
  const { t } = useTranslation();

  useEffect(() => {
    setContext((ctx: any) => {
      return {
        ...ctx,
        notification,
        handleNotification,
        isError,
        errorText,
        globalSocketMessages,
        stellarSocketMessages,
      };
    });
  }, []);

  // const setgameInfo = (gameInfo: any) => {
  //   setusers([
  //     {
  //       id: gameInfo.user_id,
  //       name: gameInfo.user_name,
  //       bet: null,
  //       cashout: null,
  //     },
  //   ])
  //   setContext(ctx => {
  //     return { ...ctx, gameInfo }
  //   })
  // }

  const setAudio = useCallback(
    (value: any) => setGameAudioHelper(value, setContext),
    [setContext]
  );

  const setMusic = useCallback(
    (value: string) => setGameAudioHelper({ music: value }, setContext),
    [setContext]
  );

  const setSound = useCallback(
    (value: string) => setGameAudioHelper({ sound: value }, setContext),
    [setContext]
  );

  const setisMusicOff = useCallback(
    (value: string) => setGameAudioHelper({ isMusicOff: value }, setContext),
    [setContext]
  );

  const setisSoundOff = useCallback(
    (value: string) => setGameAudioHelper({ isSoundOff: value }, setContext),
    [setContext]
  );

  useEffect(() => {
    const placedBet = context.placebet;
    const index = placedBet.index;
    index === "0" &&
      setContext((ctx) => {
        return { ...ctx, placedBetFirst: placedBet };
      });
    index === "1" &&
      setContext((ctx) => {
        return { ...ctx, placedBetSecond: placedBet };
      });

    updateBalanceResponce(context.placebet);

    if (placedBet.error.code !== 0 && placedBet.error.code !== 112) {
      handleErrors(placedBet.error.code, handleErrorText, handleNotification);
      setErrorCode(placedBet.error.code);
    }
    if (placedBet.error.code === 112) {
      handleNotification(Notifications.stageTimeout);
    }
  }, [context.placebet]);

  const clearBetResponse = () => {
    const defaultBet = {
      bet: "",
      currency: "",
      state: "",
      error: "",
    };
    setContext((ctx) => {
      return {
        ...ctx,
        placedBetFirst: defaultBet,
        placedBetSecond: defaultBet,
      };
    });
  };

  // const roundUpdate = (roundUpdate: any) => {
  //   setContext(ctx => {
  //     return { ...ctx, roundUpdate }
  //   })
  // }

  // const roundUserUpdate = (roundUserUpdate: any) =>
  //   setContext(ctx => {
  //     return { ...ctx, roundUserUpdate }
  //   })

  const updateBalanceResponce = (balanceUpdate: any) => {
    setContext((ctx) => {
      return { ...ctx, balanceUpdate };
    });
  };

  // const [history, addInHistory] = useHistory(context.auth.player_id)
  // const [, cashoutResponce] = useState()
  const [isError, setIsError] = useState<boolean>(false);
  const [errorText, setErrorText] = useState<string>("");
  const [errorCode, setErrorCode] = useState<number>(0);

  const [users, setusers] = useState<any[]>([]);
  const [cashoutedUser, setCashoutedUser] = useState("");

  useEffect(() => {
    roundUserUpdate(context.userupdate);
  }, [context.userupdate]);

  useEffect(() => {
    setNewRoundUser(context.userupdateArray);
  }, [context.userupdateArray]);

  const roundUserUpdate = (e: any) => {
    roundUpdateHelper(setusers, e, setCashoutedUser, context.config.prec);
    setContext((ctx) => {
      return { ...ctx, roundUserUpdate: { ...e } };
    });
    // setNewRoundUser((ctx: any) => [...ctx, e])
  };

  useEffect(() => {
    if (
      roundValue.roundupdate.state === 3 ||
      context.jackpot.status === "start"
    ) {
      setNewRoundUser([]);
      setContext((ctx) => {
        return { ...ctx, userupdateArray: [{}] };
      });
    }
  }, [roundValue.roundupdate, context.jackpot]);

  const [notification, handleNotification, notificationfadeOut] =
    useNotification();

  useEffect(() => {
    setTimeout(() => {
      setContext((ctx) => {
        return {
          ...ctx,
          notification,
          notificationfadeOut,
        };
      });
    }, 200);
  }, [notificationfadeOut, notification]);

  useEffect(() => {
    setContext((ctx) => {
      return { ...ctx, errorText };
    });
  }, [errorText]);

  useEffect(() => {
    setContext((ctx) => {
      return { ...ctx, isError };
    });
  }, [isError]);

  const handleErrorText = (text: string) => {
    setErrorText((errorText) => t(errorText ? errorText : text));
    setIsError(true);
  };

  // useEffect(() => {
  //   switch (errorCode) {
  //     case 114:
  //       setIsError(true)
  //       break
  //     default:
  //       setIsError(false)
  //       break
  //   }
  // }, [errorCode, setErrorCode, isError])

  // const receiveSettings = (str: string) => {
  //   setContext(ctx => {
  //     return { ...ctx, str }
  //   })
  // }

  const resetRoundUserUpdate = useCallback(() => {
    setContext((ctx) => {
      return {
        ...ctx,
        roundUserUpdate: {
          type: "",
          id: "",
          name: "",
          index: "",
          state: 1,
          bet: 0,
          coeff: 0,
          cashout: 0,
          currency: "USD",
        },
      };
    });
  }, []);

  // const [setStatus, receiveMessage, sendSocketMessage] = useSocketMessages({
  //   socket,
  //   MessagesList,
  //   setgameInfo,
  //   addInHistory,
  //   handleErrorText,
  //   receiveSettings,
  //   roundUserUpdate,
  //   roundUpdate,
  //   placeBetResponce,
  //   handleNotification,
  //   setErrorCode,
  //   cashoutResponce,
  //   updateBalanceResponce,
  //   setFullRoundResponce,
  //   setAirdrop,
  //   setJackpotInfo,
  //   setJackpotWin,
  //   name,
  // })

  // const stellarSocketMessages = useMemo(
  //   () => useStellarSocketMessages(sendSocketMessage),
  //   [sendSocketMessage],
  // )

  const receiveMessage = useReceiveMessages({
    setContext,
    setRoundValue,
    handleErrorText,
    handleNotification,
    setErrorCode,
  });

  useEffect(() => {
    handleFuncsInAppContext(
      setContext,
      setMusic,
      setSound,
      setisMusicOff,
      setisSoundOff,
      setAudio,
      clearBetResponse,
      resetRoundUserUpdate
    );
  }, [
    setMusic,
    setSound,
    setisMusicOff,
    setisSoundOff,
    setAudio,
    resetRoundUserUpdate,
  ]);

  return {
    // setStatus,
    receiveMessage,
    context,
    // sendSocketMessage,
    roundValue,
    // roundUpdate,
    users,
    cashoutedUser,
    newRoundUser,
    stellarSocketMessages,
    handleErrorText,
  };
}
